import { Grid, Breadcrumbs, Card, useMediaQuery } from '@geist-ui/react'

import { ReactComponent as LogoSvg } from '../../assets/navbar_logo.svg'
import { ReactComponent as HomeBtn } from '../../assets/header/home-btn.svg'
import { ReactComponent as BackBtnBlue } from '../../assets/header/back-btn-blue.svg'
import { ReactComponent as BackBtnYellow } from '../../assets/header/back-btn-yellow.svg'
import { ReactComponent as IllustrationBtnBlue } from '../../assets/header/illustration-btn-blue.svg'
import { ReactComponent as GraphicBtnYellow } from '../../assets/header/graphic-btn-yellow.svg'

import { useNavigate, useLocation } from 'react-router-dom'

export const Header = () => {
  const navigate = useNavigate()
  const navigateBack = () => navigate(-1)

  const location = useLocation()
  const isMdUp = useMediaQuery('md', { match: 'up' })

  return (
    <Card style={{ width: '100%', border: 0 }}>
      <Grid.Container gap={1} justify="space-between">
        <Grid>
          <LogoSvg
            style={{ height: '100%', cursor: 'pointer' }}
            onClick={() => navigate('/')}
          />
        </Grid>

        <Grid style={{ alignSelf: 'center', marginRight: isMdUp ? '20px' : '0px' }}>
          <Breadcrumbs separator=''>
            {
              pathToBreadcrumbs(location.pathname, isMdUp)
                .map(({ icon, href }, index) => (
                  <Breadcrumbs.Item key={index} onClick={
                    () => href === '..'
                      ? navigateBack()
                      : navigate(href)
                  }>
                    {icon}
                  </Breadcrumbs.Item>
                ))
            }
          </Breadcrumbs>
        </Grid>
      </Grid.Container>
    </Card>
  )
}

const pathToBreadcrumbs = (path: string, isMdUp: boolean) => {
  return isMdUp
    ? pathToBreadcrumbDesktop(path)
    : pathToBreadcrumbMobile(path)
}


const pathToBreadcrumbMobile = (path: string) => {

  switch (true) {
    case path === '/':
      return []
    case path.startsWith('/graphic'):
      return [
        { icon: <BackBtnBlue style={{ cursor: 'pointer', width: '500%', height: '500%' }} />, href: '..' },
        { icon: <HomeBtn style={{ cursor: 'pointer', width: '500%', height: '500%' }} />, href: '/' }
      ]
    case path.startsWith('/illustration'):
      return [
        { icon: <BackBtnYellow style={{ cursor: 'pointer', width: '500%', height: '500%' }} />, href: '..' },
        { icon: <HomeBtn style={{ cursor: 'pointer', width: '500%', height: '500%' }} />, href: '/' }
      ]
    default:
      return [
        { icon: <HomeBtn style={{ cursor: 'pointer', width: '500%', height: '500%' }} />, href: '/' },
      ]
  }
}

const pathToBreadcrumbDesktop = (path: string) => {
  switch (true) {
    case path === '/':
      return []
    case path.startsWith('/graphic'):
      return [
        { icon: <BackBtnBlue style={{ cursor: 'pointer', width: '1000%', height: '1000%' }} />, href: '..' },
        { icon: <IllustrationBtnBlue style={{ cursor: 'pointer', width: '1000%', height: '1000%' }} />, href: '/illustration' },
        { icon: <HomeBtn style={{ cursor: 'pointer', width: '1000%', height: '1000%' }} />, href: '/' },
      ]
    case path.startsWith('/illustration'):
      return [
        { icon: <BackBtnYellow style={{ cursor: 'pointer', width: '1000%', height: '1000%' }} />, href: '..' },
        { icon: <GraphicBtnYellow style={{ cursor: 'pointer', width: '1000%', height: '1000%' }} />, href: '/graphic' },
        { icon: <HomeBtn style={{ cursor: 'pointer', width: '1000%', height: '1000%' }} />, href: '/' },
      ]
    default:
      return [
        { icon: <HomeBtn style={{ cursor: 'pointer', width: '1000%', height: '1000%' }} />, href: '/' },
      ]
  }
}
